import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, unref as _unref, renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-permaBlack5 fixed right-0 top-20 rounded-l-lg h-screen z-30 pt-6 sidebar-shadow" }
const _hoisted_2 = { class: "px-4" }

import { useSlots } from 'vue'
import ModalMask from '@/components/ModalMask.vue'
interface Props {
  visible: boolean
}
interface Emits {
  (e: 'close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {



const slots = useSlots()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(ModalMask, {
          class: "top-20",
          visible: __props.visible,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
        }, null, 8, ["visible"]), [
          [_vShow, __props.visible]
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "move" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(slots).title)
              ? _renderSlot(_ctx.$slots, "title", { key: 0 })
              : _createCommentVNode("", true)
          ]),
          _renderSlot(_ctx.$slots, "default")
        ], 512), [
          [_vShow, __props.visible]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})